<template>
  <div>
    <b-modal
      ref="my-modal"
      centered
      size="xs"
      hide-footer
      hide-header
      title="Using Component Methods"
    >
      <a
        class="btn-close"
        @click="hideModal"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </a>
      <!-- <div class="d-block text-center">
        <img
          :src="require('@/assets/images/alert.png')"
          alt="Success"
          class="img-success-register"
        >
      </div> -->
      <div class="modal-text mb-1">
        <h4 class="mb-2">
          Choose Rejection Reason
        </h4>
        <b-form-group label="Please provide rejection cause by choosing following option(s)">
          <b-form-checkbox
            v-for="option in dataReason"
            :key="option.id"
            v-model="selected"
            :value="option.id"
            name="reason"
            stacked
            class="mb-1"
          >
            {{ option.reason }}
          </b-form-checkbox>
        </b-form-group>
        <div class="d-flex justify-content-center container-button mt-2">
          <b-button
            block
            variant="primary"
            @click="actionReject"
          >
            <span class="align-middle">Submit</span>
            <feather-icon
              icon="CheckCircleIcon"
              class="ml-50"
            />
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BFormCheckbox,
  BFormGroup,
} from 'bootstrap-vue'
import {
  mapActions, mapGetters,
} from 'vuex'

export default {
  components: {
    BModal,
    BButton,
    BFormCheckbox,
    BFormGroup,
  },
  props: {

  },
  data() {
    return {
      selected: [],
      options: [
        { text: 'File inappropriate', value: '1' },
        { text: 'Sex, race, religion violation', value: '2' },
        { text: 'Phising', value: '3' },
        { text: 'Scam', value: '4' },
        { text: 'Malware', value: '5' },
      ],
    }
  },
  computed: {
    ...mapGetters('datas', {
      dataReason: 'getReasonInvoice',
    }),
  },
  // mounted() {
  //   console.log(this.dataReason, 'reason')
  // },
  methods: {
    ...mapActions('finance', [
      'rejectPayment',
    ]),
    // ...mapMutations('campaign', {
    //   setReason: 'SET_REASON',
    // }),
    actionReject() {
      if (this.selected.length === 0) {
        this.fail()
      } else {
        // this.setReason(this.selected)
        const sendData = {
          invoice_no: this.$route.params.id,
          reason: this.selected,
        }
        this.rejectPayment(sendData).then(() => {
          this.hideModal()
          this.success()
        }, error => {
          console.error('err', error)
        })
      }
    },
    success() {
      this.$swal({
        title: 'Rejected!',
        text: '',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          // const routeName = this.$route.matched[0].path
          this.$router.push({ path: '/invoice' })
          // this.$swal.close()
        }
      })
    },
    fail() {
      this.$swal({
        title: 'Sorry!',
        text: 'The reason is required',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      })
    },
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
  },
}
</script>
<style scoped>
.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.img-success-register {
  margin-top: 43px;
}
.modal-text {
  text-align: left;
  font-family: 'Rubik';
  margin-top: 5px;
}

.modal-text > h4 {
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}

.modal-text > p {
  margin-top: 15px;
}
</style>
